import { createSearchParams } from "react-router-dom";

export const createQueryParams = (values: Record<string, string>) => {
  const params = createSearchParams(values);

  return params.toString();
};
